module.exports = __webpack_public_path__ + "static/csi_dataviz2-9af6ff6c74acf687dabc693e1d255a57.png";